'use strict';

import { Map } from 'immutable';

import {
    UPDATE_SHARE_BUTTONS_SHARING_EXPANDED_TYPE,
    UPDATE_SHARE_BUTTONS_EMBED_CODE_EXPANDED,
} from '../actions/shareButtons';

const SHARE_BUTTONS = 'shareButtons';
const SHARING_EXPANDED_TYPE = 'sharingExpandedType';
const EMBED_CODE_EXPANDED = 'embedCodeExpanded';

export default function videoTitlePage(state = Map(), action) {
    switch (action.type) {
        case UPDATE_SHARE_BUTTONS_SHARING_EXPANDED_TYPE:
            return state.setIn([SHARING_EXPANDED_TYPE], action.payload);
        case UPDATE_SHARE_BUTTONS_EMBED_CODE_EXPANDED:
            return state.setIn([EMBED_CODE_EXPANDED], action.payload);
        default:
            return state;
    }
}

export const sharingExpandedTypeSelector = (state) => state.getIn([SHARE_BUTTONS, SHARING_EXPANDED_TYPE], '');
export const embedCodeExpandedSelector = (state) => state.getIn([SHARE_BUTTONS, EMBED_CODE_EXPANDED], false);
